import { render } from "./MapLegend.vue?vue&type=template&id=5d9c9f86&scoped=true"
import script from "./MapLegend.vue?vue&type=script&lang=js"
export * from "./MapLegend.vue?vue&type=script&lang=js"

import "./MapLegend.vue?vue&type=style&index=0&id=5d9c9f86&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9c9f86"]])

export default __exports__